import { Box, styled } from '@mui/material';
import { spaceCadet } from '../../../../utils/colors';

const StyledBox = styled(Box)({
  display: 'flex',
  gap: 8,
  flexDirection: 'row',
  margin: '-10px -16px -10px -16px',
  alignItems: 'center',
  height: 55,

  '& .MuiButton-text': {
    textTransform: 'none',
    fontWeight: 500,
    color: spaceCadet[100],
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    border: `1px solid ${spaceCadet[100]}`,
    padding: '5px 8px',
    '& svg': {
      fontSize: 20,
    },
  },

  '& > div > .MuiBox-root.informations': {
    display: 'flex',
    gap: 4,
    backgroundColor: spaceCadet[300],
    minWidth: 160,
    padding: '4px 10px',
    borderRadius: 4,
    color: spaceCadet[800],
    flexDirection: 'column',
    flexWrap: 'wrap',

    '& > .MuiBox-root.info': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: 4,
      '& > .MuiTypography-subtitle1': {
        fontWeight: 700,
      },
    },
  },
});

export default StyledBox;
